import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { QUERY_ACCOUNTS_FAIL } from '../../actions/account/index';
import { forwardLogin } from '../../actions/login/index';
import AccountList from '../../components/maintenance/AccountList';
import Loading from '../../components/common/Loading';

class AccountListPage extends Component {
  renderList = () => {
    const { loading } = this.props;

    let displayList;
    if (loading) {
      displayList = <Loading loading={loading}></Loading>;
    } else {
      displayList = <AccountList></AccountList>;
    }

    return (
      <div className='custom-list account-list'>
        {displayList}
      </div>
    )
  }

  // no init, because user want only query list
  // componentDidMount() {
  //   const { idToken, queryAccountsData, accounts } = this.props;
  //   if (accounts.length === 0) {
  //     let noDataObj = {
  //       modelName: "",  SN: "", email: ""
  //     }

  //     if (idToken) {
  //       queryAccountsData(idToken, noDataObj);
  //     }
  //   }
  // }
  
  componentDidUpdate (prevProps, prevState, snapshot) {
    const { forwardLogin, status, history } = this.props;
    if (prevProps.status !== status) {
      if (status === QUERY_ACCOUNTS_FAIL) {
        forwardLogin("Connect timeout, please relogin.");
        history.push("/Login");
      }
    }
  }

  render() {
    return this.renderList();
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    status: state.accountReducers.status,
    accounts: state.accountReducers.accounts,
    loading: state.accountReducers.loading
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { forwardLogin }
)(AccountListPage))
